// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ece20ce0","568":"d2a990d5"}[chunkId] + ".chunk.js";
};